import { useEffect, useState } from 'react';

// Vrai sous 768 px (téléphone). Sans `matchMedia` (tests, vieux navigateurs),
// l'écran est traité comme large: la carte complète reste le cas par défaut.
const REQUETE = '(max-width: 767px)';

const lire = () => {
  try {
    return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(REQUETE).matches
      : false;
  } catch {
    return false;
  }
};

export function useEstMobile() {
  const [mobile, setMobile] = useState(lire);
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
    const requete = window.matchMedia(REQUETE);
    const suivre = () => setMobile(requete.matches);
    suivre();
    if (requete.addEventListener) requete.addEventListener('change', suivre);
    else if (requete.addListener) requete.addListener(suivre);
    return () => {
      if (requete.removeEventListener) requete.removeEventListener('change', suivre);
      else if (requete.removeListener) requete.removeListener(suivre);
    };
  }, []);
  return mobile;
}
